import { render, staticRenderFns } from "./ConsultarTransferenciaSaldo.vue?vue&type=template&id=7d9b880f&"
import script from "./ConsultarTransferenciaSaldo.vue?vue&type=script&lang=js&"
export * from "./ConsultarTransferenciaSaldo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports